import { jsx as f } from "react/jsx-runtime";
import { forwardRef as a, useRef as i, useImperativeHandle as c } from "react";
import x from "classnames";
import r from "./text-box.module.less.js";
const R = a(
  function({ className: t, variant: o = "important", ...s }, m) {
    const n = x(r.textBox, r[o], t), e = i(null);
    return c(m, () => e.current), /* @__PURE__ */ f("div", { ...s, className: n, ref: e });
  }
);
export {
  R as TextBox
};
//# sourceMappingURL=text-box.js.map
